// log in form animation variant declared here
export const loginFormVariants = {
  hidden: { scale: 0, opacity: 0 },
  visible: {
    scale: 1,
    opacity: 1,
    transition: {
      delay: 0.3,
      duration: 0.7,
      type: 'spring',
      damping: 20,
      stiffness: 500,
    },
  },
  exit: { scale: 0, opacity: 0 },
};

// section animation variant declared here
export const sectionAnimVariants = {
  initial: { y: 200, opacity: 0 },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      ease: 'easeInOut',
      y: { duration: 0.5 },
    },
  },
};

export const applicationAnimVariants = {
  initial: { y: 50, opacity: 0 },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      ease: 'easeInOut',
      y: { duration: 0.5 },
    },
  },
};

// modal animation variants declared here
export const modalAnimVariants = {
  hidden: { scale: 0, opacity: 0 },
  visible: {
    scale: 1,
    opacity: 1,
    transition: {
      duration: 0.1,
      type: 'spring',
      damping: 25,
      stiffness: 500,
    },
  },
  exit: { scale: 0, opacity: 0 },
};

export const sideModalAnimVariants = {
  hidden: { x: 200 },
  visible: {
    x: 0,
    transition: {
      duration: 0.1,
      type: 'spring',
      damping: 25,
      stiffness: 500,
    },
  },
  exit: { x: 200 },
};

// animation variants for table declared here
export const tableAnimVariants = {
  visible: {
    opacity: 1,
    transition: {
      when: 'beforeChildren',
      staggerChildren: 0.2,
      default: { ease: 'easeInOut' },
    },
  },
  hidden: {
    opacity: 0,
    transition: {
      when: 'afterChildren',
    },
  },
};

// animation variants for table row declared here
export const tableRowAnimVariants = {
  hidden: { opacity: 0, y: 100 },
  visible: { opacity: 1, y: 0, transition: { ease: 'easeInOut' } },
};

export const stackedAnimInitial = { opacity: 0, y: 100 };

// animation variants for pagination declared here
export const paginationAnimVariant = {
  initial: { y: 20, opacity: 0, transition: { duration: 0.2 } },
  animate: { y: 0, opacity: 1, transition: { duration: 0.2 } },
  exit: { y: -20, opacity: 0, transition: { duration: 0.2 } },
};
